export { default as deleteBulkAction } from './delete';
